import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import useAddFormData from '../../../../Components/Hooks/useAddFormData';
import Attachement from '../../../../Components/Utils/CustomAttrachmentupload';
import ModalContainer from '../../../../Components/Others/ModalContainer';
import { NuUpload } from '../../../../Components/Utils/Input';
import axiosInstance from '../../../../Services/axiosCommon';
import { useToast } from '../../../../Components/Others/ToastServices';
import { CancelButton } from '../../../../Components/Utils/Buttons';

const Importdoc = ({ show, onClose, getData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const [file, setFile] = useState(null);
  // const { addFormData, contextHolder } = useAddFormData();

  const formik = useFormik({
    initialValues: {},
    validationSchema: yup.object({}),
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);
      let formData = new FormData();
      console.log("sss", file);
      if (file) {
        formData.append('file', file);
      }
      await axiosInstance.post('/items/import/products', formData)
        .then(res => {
          if (res.data) {
            console.log("Created", resetForm)
            resetForm();
            onClose();
            getData();
            toast.open({
              type: "success",
              message: `Imported File Added successfully`,
              // description:'',
              // placement: 'bottomRight',
            });
          }
          else {
            setIsLoading(false);
            console.log("Failed")
            toast.open({
              type: "error",
              message: `Imported File Added failed`,
              // description: response.data.msg || 'Network error',
              // placement: 'bottomRight',
            });
          }
        }
        ).catch(err => {
          setIsLoading(false);
          console.log("Failed")
          toast.open({
            type: "error",
            message: `Imported File Added failed`,
            // description: response.data.msg || 'Network error',
            // placement: 'bottomRight',
          });
        })
    }
  });

  const handleFileChange = (e) => {
    if (e.target.files.length) {
      setFile(e.target.files[0]);
    }
  };

  if (!show) return null;

  return (
    <>
      <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center p-4">
        <div className="animate-scale-in w-full sm:w-[480px] max-w-[95vw] max-h-[85vh] bg-white py-6 px-4 sm:px-6 rounded-xl shadow-lg overflow-y-auto">

          <form onSubmit={formik.handleSubmit}>
            <div className="w-full">
              <NuUpload
                label="Import"
                width="w-full "
                onChange={handleFileChange}
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,text/comma-separated-values, text/csv, application/csv"
              />
              <div className="flex gap-3 justify-end items-center pt-4 border-t border-gray-100 mt-2">
                <button
                  type="button"
                  onClick={onClose}
                  className="px-4 py-2 text-xs font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className={`px-5 py-2 text-xs font-semibold text-white rounded-lg transition-colors ${isLoading ? 'bg-teal-300 cursor-wait' : 'bg-[#048178] hover:bg-[#036861]'}`}
                  disabled={isLoading}
                >
                  {isLoading ? 'Importing...' : 'Import'}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Importdoc;
